import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { businessWorkLocationCheckQuery } from '@/__generated__/businessWorkLocationCheckQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { WorkLocationCheckContainer } from '@/components/survey/business/work-location-check/WorkLocationCheckContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { workLocationCheckQuery } from '@/graphql/query/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

function WorkLocationCheckPage() {
  const eventAttributes = useSurveyUserEventAttributes();
  const [queryRef, loadQuery] = useQueryLoader<businessWorkLocationCheckQuery>(workLocationCheckQuery);

  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const bmanTin = useAtomValue(currentBusinessBmanTinAtom);

  useEffect(() => {
    if (refundHistoryId && bmanTin) {
      loadQuery(
        {
          bmanTin,
          refundHistoryId
        },
        { fetchPolicy: 'network-only' }
      );
    }
  }, [loadQuery, refundHistoryId, bmanTin]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_work-location-check'} eventProperty={eventAttributes}>
      <WorkLocationCheckContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

WorkLocationCheckPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default WorkLocationCheckPage;
